export const AUTH_TOKEN_KEY = "carRental-token";
export const AUTH_USER_KEY = "carRental-userData";

export const isAuthenticated = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const userData = localStorage.getItem(AUTH_USER_KEY);

  if (!token || !userData) {
    return false;
  }

  try {
    JSON.parse(userData);
    return true;
  } catch {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
    return false;
  }
};

export const persistAuthSession = ({ token, user }) => {
  if (!token || !user) {
    throw new Error("Login response did not include a valid session.");
  }

  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
};
